module.exports = __webpack_public_path__ + "img/Salesforce.427d8250.png";